import { StatementProps } from 'modules/clients/types/client.types';

export const InternalRateOfReturnInvestmentStatement = ({
  clientId,
  formValues,
  startDate,
  endDate
}: StatementProps) => {
  return <div>InternalRateOfReturnInvestmentStatement</div>;
};
